export default {
  data() {
    return {
      //判别新增、编辑的字段
      id: 'id'
    }
  },
  methods: {
    //获取vuex存储的静态数据
    getStoreData(...args) {
      args.forEach(arg=>{
        if(Array.isArray(arg)){
          if(arg.length != 2) return false;
          this.$store._actions['data/'+arg[0]] 
          && this.$store._actions['data/'+arg[0]].length 
          && this.$store._actions['data/'+arg[0]][0](arg[1]); 
        }else{
          this.$store._actions['data/'+arg] 
          && this.$store._actions['data/'+arg].length 
          && this.$store._actions['data/'+arg][0]();
        }
      });
    }
  }
}